import { HttpInterceptorFn } from '@angular/common/http';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
    // Errors are now handled by GlobalErrorHandler
    // This interceptor is kept for any future request-level error transformations
    return next(req);
};
